<template>
  <div class="footer-container">
    <div class="footer-row">
      <div class="footer-left">
        <h3> Our Schools Our Democracy (OSOD) is a 501(c)3 nonprofit
         organization. Your tax-deductible gift to OSOD will help us achieve
         our mission of protecting our Texas public schools and preserving
         our democracy. </h3>
        <div class="socials-container">
          <a
            v-for="(social, index) in socials"
            :key="index"
            :href="social.url"
            :title="social.title"
          >
            <div
              class="round-icon"
              :style="'background-color: ' + social.color"
            >
              <img :src="social.icon">
            </div>
          </a>
        </div>
        <div class="copy-right-text">
          Copyright 2026, Our Schools Our Democracy All Rights Reserved.
          <a
            class="footer-link"
            href="https://www.termsfeed.com/live/35c5a902-228e-4dc2-8e9b-087a541105a0"
            target="_blank"
          >Privacy Policy
          </a>
          |
          <a
            class="footer-link"
            href="https://www.termsfeed.com/live/472d862d-b18d-46bc-b6ad-dae7f7933a96"
            target="_blank"
          >Terms of Use
          </a>
        </div>
      </div>
      <div class="footer-right">
        <a
          class="donate-button"
          href="https://actionnetwork.org/fundraising/our-schools-our-democracy/"
          target="_blank"
        >DONATE</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    activeLang: {
      type: String,
      default: 'English'
    }
  },
  data() {
    return {
      socials: [
        {
          url: 'https://www.facebook.com/OurSchoolsOurDemocracy/',
          icon: require('@/assets/facebook.svg'),
          color: '#3e5c98',
          title: 'Follow us on Facebook'
        },
        {
          url: 'https://x.com/osodtexas',
          icon: require('@/assets/twitter.svg'),
          color: '#2fa4f0',
          title: 'Follow us on X/Twitter'
        },
        {
          url: 'https://www.instagram.com/osodtexas',
          icon: require('@/assets/insta.svg'),
          color: '#df2e75',
          title: 'Follow us on Instagram'
        },
        {
          url: 'https://bsky.app/profile/osodtexas.bsky.social',
          icon: require('@/assets/bluesky.svg'),
          color: '#589EF7',
          title: 'Follow us on Bluesky'
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

a {
  text-decoration: none;
  color: #2c3e50;
}

h3 {
  text-align: center;
  margin-top: 0;
  margin-bottom: 0;
  color: #fff;
  line-height: 1.5em;
}

.copy-right-text {
  text-align: center;
  font-size: 0.88rem;
  color: #fff;
}

.footer-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  margin: 0 auto;
  padding: 36px 0;
  width: 88%;
}

@media screen and (min-width: 700px) {
  .footer-row {
    flex-direction: row;
    align-items: center;
    width: 80%;
  }

  h3 {
    text-align: left;
  }

  .copy-right-text {
    text-align: left;
  }
}

.footer-left {
  display: flex;
  flex-direction: column;
  flex: 1;
  order: 1;
}

.footer-right {
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  order: 0;
}

@media screen and (min-width: 700px) {
  .footer-left {
    order: 0;
  }

  .footer-right {
    order: 1;
    justify-content: flex-end;
  }
}

.socials-container {
  margin-top: 18px;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

@media screen and (min-width: 700px) {
  .socials-container {
    justify-content: flex-start;
  }
}

.round-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  flex-direction: column;
  margin-right: 16px;
}

img {
  width: 50%;
  height: auto;
}

.donate-button {
  display: inline-block;
  background-color: #C7463E;
  color: #fff;
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.2em;
  padding: 18px 48px;
  text-decoration: none;
  cursor: pointer;
}

.donate-button:hover {
  background-color: #a83832;
}

</style>
